import React from "react"
import styles from "./style.module.scss"
import { Toast } from "antd-mobile"

const Button = (props) => {
  const { title, disabled = false, size, onClick } = props
  return size === "lg" ? (
    <div
      className={disabled ? styles.disabled : styles.enabled}
      onClick={() => (disabled ? disabledMsg() : onClick())}
    >
      <div>{title}</div>
    </div>
  ) : (
    <div className={styles.wrap} onClick={() => onClick()}>
      <div>{title}</div>
    </div>
  )
}

function disabledMsg() {
  Toast.info("到兑奖时间方可兑奖哦～")
}

export default Button
